// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K87-","left":"styles_left__1MPN2","navigationLink":"styles_navigationLink__2fZjX"};